import { useCallback } from 'react';
import { css } from '@emotion/react';
import { useAppDispatch } from 'redux/store';
import humps from 'humps';

import { NovoAIItemType } from 'redux/schemas/models/lecture-page';
import { setLeftPanelNovoAIItemType } from 'redux/actions/lecture-pages';

import { gray3 } from 'styles/global_defaults/colors';
import { quarterSpacing } from 'styles/global_defaults/scaffolding';

import ClickableContainer from 'components/clickable-container';
import useAiItemMetadata from '../hooks/use-ai-item-metadata';

import { config } from '../../../../../../config/config.json';

const styles = css`
  &{
    border: 1px solid ${gray3};
    border-radius: ${quarterSpacing}px;
    height: 80px;
  }
`;

type ItemProps = {
  type: NovoAIItemType
};

const AIComponentCard = (props: ItemProps) => {
  const { type } = props;
  const dispatch = useAppDispatch();
  const { itemTextMapping, itemTypeIcons } = useAiItemMetadata();

  const IconComponent = itemTypeIcons[type];

  const setNovoAIItem = useCallback(() => {
    dispatch(setLeftPanelNovoAIItemType(type));
  }, [dispatch, type]);

  if (!IconComponent) {
    return null;
  }

  return (
    <ClickableContainer
      css={styles}
      className='align-items-center flex-column py-3 px-2'
      onClick={setNovoAIItem}
      data-qa={config.pendo.novoAi.item[humps.camelize(type)]}
    >
      <IconComponent
        height={25}
        width={40}
      />
      <div className='font-weight-bold text-nowrap pt-1 text-small text-gray-1'>
        {itemTextMapping[type]}
      </div>
    </ClickableContainer>
  );
};

export default AIComponentCard;
